<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row no-gutter justify-center items-center">
                        <div class="vx-col hidden lg:block lg:w-1/2">
                            <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Two Factor Authentication Step</h4>
                                    <p>Please enter the code you received by your email.</p>
                                </div>
                                    <vs-input
                                        icon="icon icon-user"
                                        icon-pack="feather"
                                        label-placeholder="e.g 123456"
                                        v-model="form.twoFactorCode"
                                        class="w-full no-icon-border"/>

                                
                                    <div style="align-items: center;" class="flex flex-wrap justify-between my-5">
                                        <vs-button style="background: #5192f4 !important;" @click="resendOtpCode()">Resend Code</vs-button>
                                        <vs-button class="float-right" @click="submit()">Submit</vs-button>
                                    </div>

                                <vs-alert v-if="this.errorMessage" style="margin-top:15px;" color="danger" icon="new_releases" >
                                <span>{{errorMessage }}</span>
                                </vs-alert>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    export default {
        data() {
            return {
                form: {
                    twoFactorCode: null
                },
                errorMessage: null
            }
        },
        computed: {
            ...mapGetters({
                authenticated: 'auth/authenticated',
            }),
        },
        methods: {
            ...mapActions({
                verifyOtp: 'auth/verifyOtp', //inside store/storeModuldes/auth.js --> function signIn
                resendOtp: 'auth/resendOtp' //inside store/storeModuldes/auth.js --> function signIn
            }),
            submit() {
                this.$vs.loading('Verifying OTP')
                this.verifyOtp(this.form).then((res) => {
                    if(res.data.success == true){
                        this.$router.replace({
                            name: 'Brokers'
                        })
                    }
                }).catch((e) => {
                    console.log(e)
                    this.errorMessage = e
                    
                }).finally(()=>{
                    this.$vs.loading.close()
                })
            },
            resendOtpCode() {
                this.$vs.loading('Resending OTP')
                this.resendOtp().then((res) => {
                    
                }).catch((e) => {
                    console.log(e)
                    this.errorMessage = e
                    
                }).finally(()=>{
                    this.$vs.loading.close()
                })
            }
        },
    }
</script>

<style lang="scss">
#page-login {
    .social-login {
        .bg-facebook {
          background-color: #1551b1;
        }
        .bg-twitter {
          background-color: #00aaff;
        }
        .bg-google {
          background-color: #4285F4;
        }
        .bg-github {
          background-color: #333;
        }
    }
}
</style>
